import React, { useState } from 'react';
import { Dialog } from '@headlessui/react';
import {deleteFollowUp} from "../services/follow-up-service";

interface DeleteFollowUpModalProps {
    isOpen: boolean;
    followUpId: number;
    onClose: () => void;
    onDelete: (id: number) => void;
    onError: (message: string) => void;
}

const DeleteFollowUpModal: React.FC<DeleteFollowUpModalProps> = ({
                                                                   isOpen,
                                                                   followUpId,
                                                                   onClose,
                                                                   onDelete,
                                                                   onError
                                                               }) => {
    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {
        setLoading(true);
        try {
            const response = await deleteFollowUp(followUpId);
            if (response.status === 204) {
                onDelete(followUpId);
            } else {
                onError('Unable to delete follow-up. Please try again later.');
            }
        } catch (err) {
            onError('Unable to delete follow-up. Please try again later.');
        } finally {
            setLoading(false);
            onClose();
        }
    };

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            className="fixed inset-0 z-50 flex items-center justify-center"
        >
            <div
                className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm"
                aria-hidden="true"
                onClick={onClose}
            />
            <div className="relative bg-white w-full max-w-md p-6 rounded-lg shadow-lg">
                <Dialog.Title className="text-xl font-semibold mb-4 text-red-600">
                    Confirm Deletion
                </Dialog.Title>
                <p className="mb-4">
                    Are you sure you want to delete this follow-up? This action <strong>cannot</strong> be undone.
                </p>
                <div className="flex justify-end space-x-3">
                    <button
                        data-testid="close-btn"
                        onClick={onClose}
                        className="px-4 py-2 rounded border"
                        disabled={loading}
                    >
                        Cancel
                    </button>
                    <button
                        data-testid="delete-btn"
                        onClick={handleDelete}
                        className="px-4 py-2 rounded bg-red-600 text-white"
                        disabled={loading}
                    >
                        {loading ? 'Deleting...' : 'Delete'}
                    </button>
                </div>
            </div>
        </Dialog>
    );
};

export default DeleteFollowUpModal;